<template>
  <div class="project-device-info">
    <div class="app-title mb" v-if="deviceId">编辑设备</div>
    <div class="app-title mb" v-else>新增设备</div>
    <el-form class="max-width" ref="form" :model="form" :rules="rules" :label-width="labelWidth">
      <template v-if="!deviceId">
        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择类型">
            <el-option v-for="(value, index) in typeOptions" :key="index" :label="value.device_type_name" :value="value.device_type_sign"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="序列号" prop="number">
          <el-input v-model="form.number" placeholder="请输入序列号"></el-input>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="类型">
          <p>{{form.type}}</p>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="序列号">
          <p>{{form.number}}</p>
        </el-form-item>
      </template>
      <el-form-item>
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import ProjectService from '@/io/project.js';

  export default {
    name: 'ProjectDeviceInfo',
    props: {
      deviceId: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        id: this.$route.params.id,
        form: {
          type: '',
          name: '',
          number: ''
        },
        rules: {
          type: [
            {
              required: true, message: '请选择类型'
            }
          ],
          name: [
            {
              required: true, message: '请输入名称'
            }
          ],
          number: [
            {
              required: true, message: '请输入序列号'
            }
          ],
        },
        typeOptions: []
      }
    },
    watch: {
      deviceId: {
        handler(newValue, oldValue) {
          this.initTypeOptions().then(() => {
            if (newValue) {
              this.initDatas();
            }
          }).catch(() => {});
        },
        immediate: true
      }
    },
    methods: {
      initDatas() {
        ProjectService.deviceInfo(this.id, this.deviceId).then(res => {
          this.typeOptions.forEach(val => {
            if (val.device_type_sign === res.data.device_type_sign) {
              this.form.type = val.device_type_name;
            }
          });
          this.form.name = res.data.device_name;
          this.form.number = res.data.device_sn;
        }).catch(() => {})
      },
      initTypeOptions() {
        return ProjectService.deviceType().then(res => {
          this.typeOptions = res.data;
        }).catch(() => {});
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.deviceId) {
              ProjectService.editDevice(
                this.id,
                this.deviceId,
                this.form.name
              ).then(() => {
                this.$message.success('编辑成功');
                this.$emit('cancel');
                this.$emit('submit');
              }).catch(() => {});
            } else {
              ProjectService.addDevice(
                this.id,
                this.form.type,
                this.form.name,
                this.form.number
              ).then(() => {
                this.$message.success('创建成功');
                this.$emit('cancel');
                this.$emit('submit');
              }).catch(() => {});
            }
          }
        });
      },
      cancel() {
        this.$emit('cancel');
      }
    },
  }
</script>

<style lang="less" scoped>

</style>